"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const building_blocks_ui_common_1 = require("@acko-tech/building-blocks.ui.common");
const utils_1 = require("../helpers/utils");
const H3 = building_blocks_ui_common_1.styled.h3 `
    ${(0, utils_1.getStyles)({
    defaultFontSize: 'H3',
    defaultFontWeight: 'H3',
    defaultLineHeight: 'H3'
})}
  `;
exports.default = H3;
//# sourceMappingURL=heading-three.js.map